import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { DeviceManagerService } from '../../core/services/device-manager.service';

@Component({
	selector: 'mycampapp-section-edit-toolbar',
	templateUrl: './section-edit-toolbar.component.html',
	styleUrls: ['./section-edit-toolbar.component.less']
})
export class SectionEditToolbarComponent implements OnInit
{
	@Input() addDisabled = false;
	@Input() addItemName = '';
	@Input() deleteDisabled = false;
	@Input() saveDisabled = false;
	@Input() duplicateDisabled = false;
	@Input() duplicateButtonText = 'Duplicate';
	@Input() extraToolbarComponents: TemplateRef<any> | null = null;

	@Output() addClicked = new EventEmitter();
	@Output() cancelClicked = new EventEmitter();
	@Output() closeClicked = new EventEmitter();
	@Output() deleteClicked = new EventEmitter();
	@Output() duplicateClicked = new EventEmitter();
	@Output() saveClicked = new EventEmitter();

	constructor(public deviceManager: DeviceManagerService) { }

	ngOnInit(): void
	{
	}

	onCloseButtonClicked()
	{
		this.closeClicked.emit();
	}

	onCancelButtonClicked()
	{
		this.cancelClicked.emit();
	}

	onDeleteButtonClicked()
	{
		this.deleteClicked.emit();
	}

	onDuplicateButtonClicked()
	{
		this.duplicateClicked.emit();
	}

	onAddButtonClicked()
	{
		this.addClicked.emit();
	}

	onSaveButtonClicked()
	{
		this.saveClicked.emit();
	}
}
